var _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path3, _path4, _ellipse7, _path5, _path6, _ellipse8, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMascot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 80,
    viewBox: "0 0 100 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E32752",
    d: "M35.161 79.649c-1.806-.258-2.043-7.847-1.935-11.609l7.42 1.935c-1.076 3.332-3.678 9.932-5.485 9.674Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3160",
    d: "M68.71 79.971c-1.806.516-5.054-6.02-6.452-9.351l8.065-4.837c.215 4.514.193 13.672-1.613 14.188Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.355,
    cy: 38.373,
    fill: "#FFBD23",
    rx: 9.355,
    ry: 8.707
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.13,
    cy: 38.051,
    fill: "#E32752",
    rx: 11.613,
    ry: 16.768
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.355,
    cy: 8.707,
    fill: "#FFED8A",
    rx: 9.355,
    ry: 8.707,
    transform: "matrix(-1 0 0 1 100 29.667)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.129,
    cy: 8.707,
    fill: "#FFBD23",
    rx: 6.129,
    ry: 8.707,
    transform: "matrix(-1 0 0 1 98.064 29.667)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.613,
    cy: 16.768,
    fill: "#FF3160",
    rx: 11.613,
    ry: 16.768,
    transform: "matrix(-1 0 0 1 95.483 21.283)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.645,
    cy: 37.728,
    fill: "url(#mascot-gradient)",
    rx: 38.387,
    ry: 37.728
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFED8A",
    fillRule: "evenodd",
    d: "M47.419 75.325c19.69-1.61 35.161-17.828 35.161-37.597C82.58 17.96 67.11 1.741 47.419.131A39.573 39.573 0 0 1 50.644 0c21.2 0 38.387 16.892 38.387 37.728 0 20.837-17.186 37.729-38.387 37.729-1.086 0-2.162-.045-3.225-.132Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M29.343 6.338c.461-.303.93-.597 1.404-.88 5.023 5.025 11.793 16.18 11.051 33.083a1.444 1.444 0 0 1-1.189 1.361c-3.073.539-8.004 1.148-13.34 1.307-4.984.149-10.373-.093-14.94-1.178a37.508 37.508 0 0 1-.066-1.676c4.451 1.127 9.865 1.394 14.958 1.242 5.173-.154 9.96-.739 12.972-1.26.694-16.702-6.161-27.462-10.85-32ZM89.02 38.73a37.861 37.861 0 0 0 .007-1.665c-4.504 1.152-10.436 1.71-16.051 1.86-5.706.152-11.007-.12-14.057-.594-.407-9.483 1.285-17.37 3.644-23.296 1.974-4.96 4.397-8.501 6.407-10.467-.497-.266-1-.522-1.51-.766-2.137 2.23-4.491 5.852-6.396 10.637-2.453 6.164-4.19 14.326-3.75 24.103.03.661.51 1.247 1.2 1.358 3.163.51 8.655.793 14.505.638 5.497-.147 11.382-.682 16-1.809Z",
    clipRule: "evenodd"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.678,
    cy: 38.051,
    fill: "#000",
    rx: 7.097,
    ry: 16.768
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M36.113 45.132c.425-2.151.662-4.55.662-7.081 0-1.317-.064-2.598-.186-3.828-1.512-2.363-4.044-3.911-6.911-3.911s-5.399 1.549-6.911 3.912a39.008 39.008 0 0 0-.186 3.827c0 2.53.237 4.93.662 7.08 1.539 1.98 3.85 3.239 6.435 3.239 2.585 0 4.896-1.259 6.435-3.238Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M36.367 43.666c.264-1.756.408-3.646.408-5.615 0-.998-.037-1.975-.108-2.925a3.921 3.921 0 0 0-1.505-.3c-2.316 0-4.194 2.021-4.194 4.515 0 2.493 1.878 4.514 4.194 4.514.419 0 .824-.066 1.205-.19Z",
    clipRule: "evenodd"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 69.033,
    cy: 38.696,
    fill: "#000",
    rx: 7.097,
    ry: 16.123
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M75.536 45.162a34.36 34.36 0 0 0 .594-6.466c0-1.39-.077-2.737-.223-4.023-1.516-2.247-4.03-3.716-6.873-3.716-2.845 0-5.358 1.47-6.875 3.717a35.907 35.907 0 0 0-.222 4.022c0 2.3.211 4.486.593 6.465 1.538 1.958 3.88 3.209 6.504 3.209 2.622 0 4.964-1.25 6.502-3.208Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M75.788 43.644c.22-1.56.34-3.222.34-4.948 0-1.237-.061-2.442-.177-3.599a3.92 3.92 0 0 0-1.435-.27c-2.316 0-4.194 2.02-4.194 4.514 0 2.493 1.878 4.514 4.194 4.514.443 0 .87-.074 1.272-.211Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.613,
    d: "M45.807 41.275c.322 2.258 4.838 4.84 6.774.323"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M51.935 14.833c-.774-.516-1.613.86-1.935 1.613-.215-.968-1.032-2.645-2.58-1.613-1.936 1.29 1.612 4.837 2.58 4.515.968-.323 2.903-3.87 1.935-4.515Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mascot-gradient",
    x1: 12.105,
    x2: 75.349,
    y1: 0,
    y2: 69.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#FFDE2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9500"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascot);
export default __webpack_public_path__ + "static/media/mascot.ea2a7eaf.svg";
export { ForwardRef as ReactComponent };